import {atom} from "recoil";

type TipModalType = {
  toggle: boolean;
};
export const tipsModalState = atom<boolean>({
  key: "tipsModalState",
  default: false,
});
